export interface ProductsByAvailabilityResponse extends Product {
    isVisibleForSelfService: boolean;
}

export interface ProductVariantResponse extends ProductVariant {
    isVisibleForSelfService: boolean;
    availability: Availability;
}

export type Product = {
    isPaintProtection: boolean;
    isExtendedWarranty: boolean;
    isExteriorProtection: boolean;
    variants: ProductVariant[];
};

export type ProductVariant = {
    extraId: number;
    lengthOfCoverInMonths: any;
    description: string;
    price: Price;
};

export type Availability = {
    soldFrom: string;
    soldTo: string | null;
    availableTo: string | null;
};

export type Price = {
    basicPrice?: number;
    vatAmount?: number;
};

export const getGrossPrice = (price: Price): number => {
    return Math.round((price.basicPrice ?? 0) + (price.vatAmount ?? 0));
};
